/* Arreglo global del carrito (todas las páginas).
   1) En páginas sin header no existe #cart-icon-bubble; al actualizar el carrito el tema
      escribe el contador encima del carrito, lo borra y deja la página bloqueada.
      Creamos un botón flotante con ese id: arregla el error y permite volver al carrito.
   2) Si la página queda bloqueada (overflow-hidden) sin carrito abierto, la desbloquea. */
(function () {
  if (window.__vlCartFix) return;
  window.__vlCartFix = true;
  var SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  function fab() {
    if (document.getElementById('cart-icon-bubble')) return;
    var a = document.createElement('a');
    a.id = 'cart-icon-bubble'; a.href = cartUrl; a.className = 'vl-cart-fab';
    a.setAttribute('data-cart-icon-type', 'cart'); a.setAttribute('aria-label', 'Ver carrito'); a.setAttribute('role', 'button');
    a.innerHTML = '<span class="svg-wrapper"><span class="cart-icon-cart">' + SVG + '</span></span>';
    document.body.appendChild(a);
    a.addEventListener('click', function (e) {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { e.preventDefault(); d.open(a); }
    });
    fetch(cartUrl + '.js').then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.item_count > 0 && !a.querySelector('.cart-count-bubble')) {
        var b = document.createElement('div'); b.className = 'cart-count-bubble';
        b.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>';
        a.appendChild(b);
      }
    }).catch(function () {});
  }
  function unlock() {
    var d = document.querySelector('cart-drawer');
    if (document.body.classList.contains('overflow-hidden') && (!d || !d.classList.contains('active'))) {
      var other = document.querySelector('details[open] .menu-drawer, .modal[open], details-modal details[open], quick-add-modal[open], product-modal[open]');
      if (!other) document.body.classList.remove('overflow-hidden');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fab); else fab();
  setInterval(unlock, 1500);
})();